import Map, { Marker } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Text } from '@mantine/core';
import { useEffect, useRef } from 'react';

const getHeight = (isSmall, height, showCoordinates) => {
  if (isSmall) {
    return showCoordinates ? 180 : 0;
  }
  return height;
};

const StaticMap = ({
  latitude,
  longitude,
  zoom = 11.5,
  accessToken,
  height,
  isSmall,
  showCoordinates,
}) => {
  const finalHeight = getHeight(isSmall, height, showCoordinates);
  const width = isSmall ? '100%' : 'initial';
  const newStyles = showCoordinates
    ? {}
    : { display: 'flex', justifyContent: 'center', alignItems: 'center' };

  const mapRef = useRef(null);

  useEffect(() => {
    if (mapRef.current && mapRef.current.getMap()) {
      const map = mapRef.current.getMap();
      map.jumpTo({
        center: [longitude, latitude],
        zoom: zoom,
      });
    }
  }, [latitude, longitude, zoom]);

  return (
    <div
      style={{
        filter: 'grayscale(100%)',
        height: `${finalHeight}px`,
        width,
        ...newStyles,
      }}
    >
      {showCoordinates === false ? (
        isSmall ? null : (
          <Text color="dimmed" size="sm">
            No geolocation data available.
          </Text>
        )
      ) : (
        <Map
          ref={mapRef}
          mapboxAccessToken={accessToken}
          viewState={{
            longitude: longitude,
            latitude: latitude,
            zoom: zoom,
          }}
          style={{ borderRadius: '8px', height: `${finalHeight}px`, width }}
          mapStyle="mapbox://styles/mapbox/light-v10"
          interactive={false}
          attributionControl={false}
          dragRotate={false}
          touchZoomRotate={false}
        >
          <Marker longitude={longitude} latitude={latitude} anchor="center">
            <div
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor: 'black',
              }}
            />
          </Marker>
        </Map>
      )}
    </div>
  );
};

export default StaticMap;